import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { actions } from '../lib'
import { isFullyAuthenticated } from '../util'
import MarketingPanel from './MarketingPanel'
import { FormGroup, Input, Label, SubmitButton } from './styled'

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
  loginData: auth.loginData,
})

const mapDispatchToProps = {
  authSecondFactor: actions.authSecondFactor,
  authUser: actions.authUser,
}

export class SecondFactor extends Component {
  static contextTypes = {
    onFullyAuthenticated: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired,
  }

  static propTypes = {
    // eslint bug
    // eslint-disable-next-line react/no-unused-prop-types
    loginData: PropTypes.object.isRequired,
    // eslint bug
    // eslint-disable-next-line react/no-unused-prop-types
    authSecondFactor: PropTypes.func.isRequired,
    authUser: PropTypes.func.isRequired,
  }

  state = {
    code: '',
  }

  onChangeCode = e => {
    this.setState({ code: e.target.value })
  }

  submit = async e => {
    e.preventDefault()
    await this.props.authSecondFactor(this.state.code)
    const { loginData, location } = this.props
    if (loginData.fullyAuthenticated) {
      await this.props.authUser()
      if (isFullyAuthenticated()) {
        const { redirectPath = '/' } = location.query
        this.context.onFullyAuthenticated(this.context.router, redirectPath)
      }
    }
  }

  canSubmit() {
    return this.state.code.length === 6
  }

  render() {
    return (
      <MarketingPanel title="Verify your account">
        <p>
          Please check your registered email account for a verification code and
          enter it below.
        </p>
        <FormGroup>
          <form name="form" onSubmit={this.submit} noValidate>
            <Label htmlFor="code">Verification Code</Label>
            <Input
              type="text"
              name="code"
              id="code"
              required
              value={this.state.code}
              onChange={this.onChangeCode}
            />

            <SubmitButton
              type="submit"
              kind="primary"
              disabled={!this.canSubmit()}
              value="Submit"
              style={{ marginTop: '1rem' }}
            />
          </form>
        </FormGroup>
      </MarketingPanel>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SecondFactor)



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/SecondFactor.js